/**
 * Funders dropdown — builds a <select> from each .funder-group's first
 * heading and toggles groups. Progressive enhancement: without JS all
 * groups render visible (the select doesn't exist).
 */

export default function funderDropdowns() {
  document.querySelectorAll<HTMLElement>('[data-funders-dropdown]').forEach((block) => {
    const groups = Array.from(block.querySelectorAll<HTMLElement>('.funder-group'));
    if (groups.length < 2) return;

    const select = document.createElement('select');
    select.className = 'funders-select';
    select.setAttribute('aria-label', 'View funders and donors by group');

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select';
    select.append(placeholder);

    groups.forEach((group, i) => {
      const heading = group.querySelector('h2, h3, h4');
      const option = document.createElement('option');
      option.value = String(i);
      option.textContent = heading?.textContent?.trim() ?? `Group ${i + 1}`;
      select.append(option);
      group.hidden = true;
    });

    // the content lists an "All Funders" choice alongside the groups
    const all = document.createElement('option');
    all.value = 'all';
    all.textContent = 'All Funders';
    select.append(all);

    select.addEventListener('change', () => {
      groups.forEach((group, i) => {
        group.hidden = select.value !== 'all' && select.value !== String(i);
      });
    });

    block.prepend(select);
  });
}
